export type UnitEntryDraft = {
  equipmentId: string;
  contactName: string;
  contactPhone: string;
};

/**
 * Un nom de contact sans numéro n'est pas exploitable sur le terrain : dès qu'un nom
 * est saisi, le téléphone devient obligatoire. Règle reprise de la saisie unitaire
 * de la version précédente.
 */
export function isContactPhoneRequired(draft: UnitEntryDraft): boolean {
  return draft.contactName.trim() !== '';
}

/** Le numéro d'équipement est le seul champ toujours obligatoire. */
export function isUnitEntryValid(draft: UnitEntryDraft): boolean {
  if (draft.equipmentId.trim() === '') {
    return false;
  }

  return !isContactPhoneRequired(draft) || draft.contactPhone.trim() !== '';
}
